(() => {
  if (!customElements.get('novex-fallback-gallery')) customElements.define('novex-fallback-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const images = [...this.querySelectorAll('[data-fallback-image]')];
      const thumbs = [...this.querySelectorAll('[data-fallback-index]')];
      let active = 0;
      const show = (index) => {
        active = (index + images.length) % images.length;
        images.forEach((image, i) => { image.hidden = i !== active; });
        thumbs.forEach((thumb, i) => { if (i === active) thumb.setAttribute('aria-current', 'true'); else thumb.removeAttribute('aria-current'); });
        this.querySelector('[data-fallback-status]').textContent = `${active + 1} / ${images.length}`;
      };
      this.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-fallback-index]');
        const step = event.target.closest('[data-fallback-step]');
        if (thumb) show(Number(thumb.dataset.fallbackIndex));
        if (step) show(active + Number(step.dataset.fallbackStep));
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); show(active + (event.key === 'ArrowRight' ? 1 : -1)); }
      });
      let start;
      const viewer = this.querySelector('.novex-fallback-gallery__viewer');
      viewer.addEventListener('pointerdown', (event) => { start = { x: event.clientX, y: event.clientY }; });
      viewer.addEventListener('pointerup', (event) => {
        if (start && Math.abs(event.clientX - start.x) > 45 && Math.abs(event.clientY - start.y) < 60) show(active + (event.clientX < start.x ? 1 : -1));
        start = null;
      });
      viewer.addEventListener('pointercancel', () => { start = null; });
      show(0);
    }
  });
  // Structure existing rich descriptions without changing their commercial content.
  const enhanceDescriptions = (scope = document) => {
    scope.querySelectorAll('.novex-product-summary__content:not([data-structured])').forEach((content) => {
      content.dataset.structured = 'true';
      Array.from(content.children).filter((node) => /^H[23]$/.test(node.tagName)).forEach((heading, index) => {
        const body = [];
        let sibling = heading.nextElementSibling;
        while (sibling && !/^H[23]$/.test(sibling.tagName)) {
          body.push(sibling);
          sibling = sibling.nextElementSibling;
        }
        if (!heading.textContent.trim() || !body.some((node) => node.textContent.trim() || node.querySelector('img,video'))) {
          heading.remove();
          return;
        }
        const details = document.createElement('details');
        details.className = 'novex-description-group';
        details.open = index === 0;
        const summary = document.createElement('summary');
        summary.textContent = heading.textContent;
        heading.replaceWith(details);
        details.append(summary, ...body);
      });
    });
  };
  document.addEventListener('DOMContentLoaded', () => enhanceDescriptions());
  document.addEventListener('shopify:section:load', (event) => enhanceDescriptions(event.target));
  const key = 'novex-favorites';
  const read = () => { try { return JSON.parse(localStorage.getItem(key) || '[]'); } catch { return []; } };
  const render = () => {
    const favorites = read();
    document.querySelectorAll('[data-novex-favorite]').forEach((button) => {
      const active = favorites.includes(button.dataset.novexFavorite);
      button.setAttribute('aria-pressed', String(active));
      button.textContent = active ? '♥' : '♡';
    });
    document.querySelectorAll('[data-novex-favorite-count]').forEach((node) => { node.textContent = favorites.length; });
  };
  const updateCommercialCounts = () => {
    document.querySelectorAll('[data-id][id="product-grid"]').forEach((grid) => {
      const count = grid.querySelectorAll('[data-novex-commercial-card]').length;
      if (!count) return;
      const container = grid.closest('collection-component') || document;
      container.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach((node) => {
        const label = `${count} productos`;
        if (node.textContent.trim() !== label) node.textContent = label;
      });
    });
  };
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-novex-favorite]');
    if (!button) return;
    const favorites = read();
    const handle = button.dataset.novexFavorite;
    localStorage.setItem(key, JSON.stringify(favorites.includes(handle) ? favorites.filter((item) => item !== handle) : [...favorites, handle]));
    render();
  });
  document.addEventListener('DOMContentLoaded', () => {
    render();
    updateCommercialCounts();
    const toggle = document.querySelector('[data-novex-menu-toggle]');
    const close = document.querySelector('[data-novex-menu-close]');
    const menu = document.getElementById('novex-mobile-menu');
    const setMenu = (open) => {
      if (!menu || !toggle) return;
      menu.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('overflow-hidden', open);
      if (open) menu.querySelector('input,button,a')?.focus(); else toggle.focus();
    };
    toggle?.addEventListener('click', () => setMenu(menu?.hidden));
    close?.addEventListener('click', () => setMenu(false));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setMenu(false); });
  });
  document.addEventListener('shopify:section:load', updateCommercialCounts);

  const initCountdowns = () => {
    document.querySelectorAll('[data-novex-countdown]').forEach((countdown) => {
      if (countdown.dataset.ready === 'true') return;
      countdown.dataset.ready = 'true';
      const target = new Date(countdown.dataset.target).getTime();
      const complete = countdown.parentElement.querySelector('[data-novex-countdown-complete]');
      if (!Number.isFinite(target)) return;
      let timer;
      const update = () => {
        const remaining = Math.max(0, target - Date.now());
        const totalSeconds = Math.floor(remaining / 1000);
        const values = {
          days: Math.floor(totalSeconds / 86400),
          hours: Math.floor((totalSeconds % 86400) / 3600),
          minutes: Math.floor((totalSeconds % 3600) / 60),
          seconds: totalSeconds % 60,
        };
        Object.entries(values).forEach(([keyName, value]) => {
          const node = countdown.querySelector(`[data-${keyName}]`);
          if (node) node.textContent = String(value).padStart(2, '0');
        });
        if (remaining === 0) {
          countdown.hidden = true;
          if (complete) { complete.hidden = false; complete.textContent = countdown.dataset.complete; }
          if (timer) window.clearInterval(timer);
        }
      };
      update();
      if (Date.now() < target) timer = window.setInterval(update, 1000);
    });
  };
  document.addEventListener('DOMContentLoaded', initCountdowns);
  document.addEventListener('shopify:section:load', initCountdowns);

  const whatsappNumber = '59899852787';
  const whatsappUrl = (message) => `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
  const formatUyu = (amountInCents) => `$${new Intl.NumberFormat('es-UY', { maximumFractionDigits: 0 }).format(amountInCents / 100)} UYU`;

  const initPurchaseNotice = () => {
    const notice = document.querySelector('[data-novex-purchase-notice]');
    if (!notice) return;
    const closeButtons = notice.querySelectorAll('[data-novex-purchase-notice-close]');
    const close = () => {
      notice.hidden = true;
      document.body.classList.remove('overflow-hidden');
    };
    closeButtons.forEach((button) => button.addEventListener('click', close));
    notice.addEventListener('click', (event) => { if (event.target === notice) close(); });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !notice.hidden) close(); });
    try {
      if (!window.Shopify?.designMode && sessionStorage.getItem('novex:purchase-notice-shown') !== 'true') {
        sessionStorage.setItem('novex:purchase-notice-shown', 'true');
        window.setTimeout(() => {
          notice.hidden = false;
          document.body.classList.add('overflow-hidden');
          notice.querySelector('[data-novex-purchase-notice-close]')?.focus();
        }, 800);
      }
    } catch {
      notice.hidden = false;
    }
  };

  const openCartOnWhatsApp = async (button) => {
    if (button.dataset.loading === 'true') return;
    button.dataset.loading = 'true';
    button.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('cart-unavailable');
      const cart = await response.json();
      if (!Array.isArray(cart.items) || cart.items.length === 0) return;
      const lines = ['Hola NOVEX, quiero coordinar esta compra:', ''];
      cart.items.forEach((item) => {
        const variant = item.variant_title && item.variant_title !== 'Default Title' && item.variant_title !== item.product_title ? `\nVariante: ${item.variant_title}` : '';
        const productLink = new URL(item.url, window.location.origin).href;
        lines.push(`• ${item.product_title}${variant}\nCantidad: ${item.quantity}\nPrecio: ${formatUyu(item.final_price)}\n${productLink}`, '');
      });
      lines.push(`Total: ${formatUyu(cart.total_price)}`, '', 'Vi los productos en la web de NOVEX y quiero coordinar el pago y la entrega.');
      window.open(whatsappUrl(lines.join('\n')), '_blank', 'noopener');
    } finally {
      button.dataset.loading = 'false';
      button.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('click', (event) => {
    const checkoutButton = event.target.closest('[data-novex-whatsapp-checkout]');
    if (checkoutButton) {
      event.preventDefault();
      openCartOnWhatsApp(checkoutButton).catch(() => {
        window.open(whatsappUrl('Hola NOVEX, quiero coordinar una compra que armé en la web.'), '_blank', 'noopener');
      });
      return;
    }
    const productButton = event.target.closest('[data-novex-product-whatsapp]');
    if (!productButton) return;
    event.preventDefault();
    const scope = productButton.closest('.shopify-section') || document;
    const variantId = scope.querySelector('input.product-variant-id')?.value;
    let variantTitle = '';
    try {
      const variants = JSON.parse(scope.querySelector('[data-novex-product-variants]')?.textContent || '[]');
      variantTitle = variants.find((variant) => String(variant.id) === String(variantId))?.title || '';
    } catch {}
    const variantText = variantTitle && variantTitle !== 'Default Title' && variantTitle !== productButton.dataset.productTitle ? variantTitle : 'única disponible';
    const productUrl = productButton.dataset.productUrl || window.location.href;
    const message = `Hola NOVEX, estoy interesado en ${productButton.dataset.productTitle}, variante ${variantText}. Lo vi en la web y quisiera recibir información para coordinar la compra.\n${productUrl}`;
    window.open(whatsappUrl(message), '_blank', 'noopener');
  });

  document.addEventListener('DOMContentLoaded', initPurchaseNotice);
})();
